import './Page.css';
import DeckComponent from "../componetns/menu/deck/DeckComponent";
import CardVeryBig from "../componetns/card/CardVeryBig";
import React from "react";

function Deck() {
    return (
        <div className="main_work_field">
            <CardVeryBig/>
            <DeckComponent/>
        </div>
    );
}

export default Deck;
